import { ordenPaises } from "./ordenPaisesAlbum";

export const updateEstadoFigurita = {
  album: (figurita, figuritas, seccion) =>
    seleccionarFiguritasAlbum(figurita, figuritas, seccion),
  late: (figurita, figuritas, seccion) =>
    seleccionarFiguritasLate(figurita, figuritas, seccion),
  nola: (figurita, figuritas, seccion) =>
    seleccionarFiguritasNola(figurita, figuritas, seccion),
  repe: (figurita, figuritas, seccion) =>
    seleccionarFiguritasRepe(figurita, figuritas, seccion),
};

const seleccionarFiguritasAlbum = (figurita, figuritas, seccion) => {
  let updatedFigurita = { ...figurita };
  if (updatedFigurita.estado === "nola") {
    updatedFigurita.estado = "late";
  } else if (updatedFigurita.estado === "late") {
    updatedFigurita.estado = "repe";
  } else {
    updatedFigurita.estado = "nola";
  }
  return updateValue(figuritas, updatedFigurita, seccion);
};

const seleccionarFiguritasLate = (figurita, figuritas, seccion) => {
  let updatedFigurita = { ...figurita };
  updatedFigurita.estado = "repe";

  if (figurita.estado === "repe") {
    updatedFigurita.estado = "late";
  }

  return updateValue(figuritas, updatedFigurita, seccion);
};

const seleccionarFiguritasNola = (figurita, figuritas, seccion) => {
  let updatedFigurita = { ...figurita };
  updatedFigurita.estado = "late";

  return updateValue(figuritas, updatedFigurita, seccion);
};

const seleccionarFiguritasRepe = (figurita, figuritas, seccion) => {
  let updatedFigurita = { ...figurita };
  updatedFigurita.estado = "late";

  return updateValue(figuritas, updatedFigurita, seccion);
};

const sortSeccion = (seccionFiguritaUpdated) => {
  return seccionFiguritaUpdated.sort((a, b) => {
    return /^[0-9]+$/.test(a.numero)
      ? parseInt(a.numero) - parseInt(b.numero)
      : a.numero.localeCompare(b.numero);
  });
};

const updateValue = (figuritas, updatedFigurita, seccion) => {
  const listadoFiguritas = { ...figuritas.album };

  const seccionFigurita = listadoFiguritas[seccion];
  const seccionFiguritaUpdated = [
    ...seccionFigurita.filter(
      (object) => object.numero !== updatedFigurita.numero
    ),
    updatedFigurita,
  ];

  listadoFiguritas[seccion] = sortSeccion(seccionFiguritaUpdated);

  return { ...figuritas, album: listadoFiguritas };
};

export const albumKeysSorted = (figuritasSorted) => {
  return Object.keys(figuritasSorted).sort((a, b) => {
    return (
      ordenPaises[a.toLowerCase().trim()] - ordenPaises[b.toLowerCase().trim()]
    );
  });
};
export const getCantidadFiguritas = (figuritas) => {
  let cantidad = 0;

  Object.keys(figuritas).forEach((key) => {
    cantidad += figuritas[key].filter(
      (seccion) => seccion.estado === "late" || seccion.estado === "repe"
    ).length;
  });
  return cantidad;
};

export const getCantidadFiguritasEstado = (figuritas, estado) => {
  let cantidad = 0;

  Object.keys(figuritas).forEach((key) => {
    cantidad += figuritas[key].filter(
      (seccion) => seccion.estado === estado
    ).length;
  });
  return cantidad;
};

export const getTextFiguritas = (figuritas, estado) => {
  let figuritasText = "*" + estado.toUpperCase() + "*\n";

  albumKeysSorted(figuritas).forEach((key) => {
    const seccionFiguritas = figuritas[key].filter(
      (seccion) => seccion.estado === estado
    );

    if (seccionFiguritas.length > 0) {
      figuritasText += "*" + key.trim() + "*\n";
      seccionFiguritas.forEach((figurita, index) => {
        figuritasText += `${index === 0 ? "" : ","} ${figurita.numero}`;
      });
      figuritasText += "\n";
    }
  });
  return figuritasText;
};
